/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { ModuleWithProviders, NgModule, provideAppInitializer } from '@angular/core'
import { ProfileMockApiInterceptor } from './mock-api.interceptor'
import { ProfileMockApiService } from './mock-api.service'

@NgModule({
  providers: [
    ProfileMockApiService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProfileMockApiInterceptor,
      multi: true,
    },
  ],
})
export class ProfileMockApiModule {
  /**
   * forRoot method for setting user configuration
   *
   * @param mockDataServices
   */
  static forRoot(mockDataServices: any[]): ModuleWithProviders<ProfileMockApiModule> {
    return {
      ngModule: ProfileMockApiModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = (
            () => () =>
              undefined
          )()
          return initializerFn()
        }),
      ],
    }
  }
}
